// removed by extract-text-webpack-plugin
module.exports = {"ui":"token_ui_y457vz","inline":"token_inline_75l3a0","large":"token_large_aqm4tg","normal":"token_normal_3vqhvd"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/img/token/token.scss
// module id = 523
// module chunks = 0